var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 178,
    viewBox: "0 0 308 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2483_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    width: 307.631,
    height: 177.667,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    width: 307.631,
    height: 177.667,
    rx: 16,
    fill: "url(#paint0_radial_2483_79)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.034 88.5809C182.034 91.5172 182.178 94.4245 182.457 97.2932C182.457 97.3125 182.457 97.3318 182.467 97.3511C182.534 98.0562 182.611 98.7517 182.698 99.4471C182.785 100.171 182.881 100.886 182.987 101.601C183.093 102.316 183.208 103.021 183.333 103.736C183.458 104.441 183.593 105.155 183.728 105.861C183.949 106.962 184.19 108.063 184.45 109.154C184.642 109.966 184.864 110.767 185.076 111.569C185.143 111.82 185.21 112.071 185.278 112.332C185.538 113.269 185.817 114.206 186.115 115.143C186.135 115.201 186.154 115.259 186.173 115.326C197.455 151.015 230.724 176.891 270.048 176.891L270.048 264.314L314.05 221.438L358.062 176.747L358.062 87.335L270.048 87.335L357.908 0.41539L275.035 0.415383C273.379 0.318794 271.723 0.2705 270.048 0.2705C230.753 0.270497 197.494 26.1078 186.192 61.7778C186.154 61.884 186.125 61.9902 186.086 62.0965C185.807 62.9948 185.538 63.893 185.287 64.801C185.201 65.0907 185.133 65.3805 185.056 65.6799C184.845 66.443 184.642 67.2157 184.46 67.998C184.19 69.0895 183.949 70.1906 183.728 71.3013C183.593 72.0064 183.458 72.7212 183.333 73.4263C183.208 74.141 183.093 74.8461 182.987 75.5609C182.881 76.2756 182.785 76.9904 182.698 77.7148C182.611 78.4102 182.534 79.1056 182.467 79.8107C182.457 79.8301 182.457 79.8494 182.457 79.8687C182.178 82.7374 182.034 85.6447 182.034 88.5809Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2483_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.053 10.352L242.046 10.3662L242.039 10.4389C241.945 11.4188 241.838 12.3853 241.718 13.352L241.718 13.3539C241.597 14.3608 241.463 15.3544 241.316 16.3482C241.169 17.3411 241.008 18.3211 240.834 19.3153C240.66 20.2961 240.473 21.2909 240.285 22.2738C239.977 23.8049 239.642 25.3358 239.281 26.8529L239.281 26.8532C239.077 27.7141 238.849 28.5657 238.621 29.4216C238.551 29.6848 238.48 29.9483 238.41 30.2126L238.41 30.2128C238.317 30.5612 238.223 30.9115 238.129 31.2755C237.768 32.5758 237.381 33.8761 236.966 35.1766L236.966 35.1773C236.94 35.2557 236.912 35.3417 236.883 35.4421C221.19 85.0751 174.922 121.058 120.237 121.058H119.843V121.451V242.491L59.1248 183.327L59.1191 183.321L-2.16788 121.088V-3.10461H120.237H121.194L120.514 -3.7781L-1.38902 -124.375H113.28H113.291L113.303 -124.376C115.605 -124.51 117.907 -124.578 120.237 -124.578C174.884 -124.578 221.14 -88.6458 236.858 -39.0369L236.86 -39.0293L236.863 -39.0217C236.887 -38.9563 236.908 -38.8898 236.932 -38.8145L236.933 -38.8116C236.955 -38.742 236.979 -38.6647 237.007 -38.586C237.395 -37.3378 237.769 -36.0917 238.116 -34.8332L238.118 -34.8251C238.204 -34.5398 238.274 -34.2582 238.349 -33.9618C238.377 -33.8482 238.406 -33.7324 238.437 -33.6134L238.439 -33.6062C238.733 -32.5453 239.014 -31.4726 239.267 -30.3876L239.268 -30.3829C239.643 -28.8675 239.977 -27.3377 240.285 -25.7931C240.473 -24.8103 240.66 -23.8156 240.834 -22.835C241.008 -21.8408 241.169 -20.8608 241.316 -19.8679C241.463 -18.8741 241.597 -17.8805 241.718 -16.8736L241.718 -16.8717C241.838 -15.905 241.945 -14.9385 242.039 -13.9586L242.046 -13.8859L242.053 -13.8717C242.441 -9.88358 242.642 -5.84183 242.642 -1.75986C242.642 2.32212 242.441 6.36389 242.053 10.352ZM242.051 -13.9232C242.051 -13.9234 242.051 -13.9234 242.051 -13.9228C242.051 -13.9229 242.051 -13.923 242.051 -13.923V-13.9232Z",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 0.787281,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2483_79",
    x: -31.6909,
    y: -130.482,
    width: 303.856,
    height: 426.654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23.6184
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.174764 0 0 0 0 0.16651 0 0 0 0 0.579167 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2483_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2483_79",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2483_79",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.429 270.32) rotate(-90) scale(460.314 383.409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55653,
    stopColor: "#5926F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4828A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2483_79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    width: 307.631,
    height: 177.667,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBg);
export default __webpack_public_path__ + "static/media/card_bg.68fe50910d20896ba613ec2ce121d562.svg";
export { ForwardRef as ReactComponent };